export const productsCatalogGetters = {
  productsCatalogData: (state) => state.productsCatalogData,
  productList: (state) => state.productList,
  productListGPTContext: (state) => {
    return createLeanProductList(state.productList?.products);
  },
  productDetails: (state) => state.productDetails,
}


function createLeanProductList(products) {
  return products.map(product => ({
      product_id: product.product_id,
      catalog_no: product.catalog_no,
      barcode: product.barcode,
      release_artist: product.release_artist,
      release_title: product.release_title,
      version: product.version,
      format_name: product.format_name,
      product_type_id: product.product_type_id,
      price_code_name: product.price_code_name
  }));
}
